import { Trans } from '@lingui/react';
import { NavStepper } from '../../../../components/steppers/nav-stepper/NavStepper';
import { NavStepperStep } from '../../../../components/steppers/nav-stepper/NavStepperStep';
import { WpStepLanguages } from '../../common/components/steps/StepLanguages';
import { useWarrantProgramSuspenseQuery } from '../../WarrantProgram.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { WpStepDates } from '../../common/components/steps/StepDates';
import { WpStepValuation } from '../../common/components/steps/StepValuation';
import { WpStepMaxNumberOfOptions } from '../../common/components/steps/StepMaxNumberOfOptions';
import { WpStepShareClasses } from '../../common/components/steps/StepShareClasses';
import { QesoStepSharePrice } from './steps/SharePrice';
import { QesoStepSummary } from './steps/Summary';
import { WpStepOtherSettings } from '../../common/components/steps/OtherSettings';

export const QesoProgramStepper = ({ warrantProgramId }: { warrantProgramId: string }) => {
  const companyId = useCompanyId();
  const {
    data: { warrantProgram, employeeOptionsErrors },
  } = useWarrantProgramSuspenseQuery({ variables: { companyId, warrantProgramId, getQesoErrors: true } });

  return (
    <NavStepper path="*" onStepSaved={() => Promise.resolve()}>
      {warrantProgram.usesStepper && (
        <NavStepperStep
          index
          path="language"
          label={<Trans id="Language" />}
          validatorStatus={employeeOptionsErrors!.language}
        >
          <WpStepLanguages warrantProgram={warrantProgram} />
        </NavStepperStep>
      )}

      <NavStepperStep
        index={!warrantProgram.usesStepper}
        path="dates"
        label={<Trans id="Important Dates" />}
        validatorStatus={employeeOptionsErrors!.dates}
      >
        <WpStepDates warrantProgram={warrantProgram} />
      </NavStepperStep>

      {warrantProgram.usesStepper && (
        <NavStepperStep
          path="valuation"
          label={<Trans id="Company Valuation" />}
          validatorStatus={employeeOptionsErrors!.valuation}
        >
          <WpStepValuation warrantProgram={warrantProgram} />
        </NavStepperStep>
      )}

      <NavStepperStep
        path="max-number-of-options"
        label={<Trans id="Max Number of Options" />}
        validatorStatus={employeeOptionsErrors!.maxNumberOfOptions}
      >
        <WpStepMaxNumberOfOptions warrantProgram={warrantProgram} />
      </NavStepperStep>

      <NavStepperStep
        path="share-classes"
        label={<Trans id="Share Classes" />}
        validatorStatus={employeeOptionsErrors!.shareClasses}
      >
        <WpStepShareClasses warrantProgram={warrantProgram} />
      </NavStepperStep>

      <NavStepperStep
        path="share-price"
        label={<Trans id="Share Price" />}
        validatorStatus={employeeOptionsErrors!.sharePrice}
      >
        <QesoStepSharePrice warrantProgram={warrantProgram} />
      </NavStepperStep>

      <NavStepperStep path="summary" label={<Trans id="Summary" />} validatorStatus={null}>
        <QesoStepSummary warrantProgram={warrantProgram} />
      </NavStepperStep>

      <NavStepperStep path="other-settings" label={<Trans id="Other Settings" />} validatorStatus={null}>
        <WpStepOtherSettings warrantProgram={warrantProgram} />
      </NavStepperStep>
    </NavStepper>
  );
};
